import React, { Component } from 'react'
import classnames from 'classnames'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import MemberBenefitCardHeaderStyles from '../../styles/components/member-benefit-card-header'
import { Row, Col } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import CardHeader from '@material-ui/core/CardHeader'
import Divider from '@material-ui/core/Divider'
import Loading from '../../widgets/Loading'
import RBButton from '../../controls/RBButton'
import { localize, getFullLocale } from '../../util/Localizer'
import TitledLabel from '../../controls/TitledLabel'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { injectIntl } from 'react-intl'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import Tooltip from '../../controls/Tooltip'
import { Colors } from '../../theme'
import Config from '../../Config'

// to be added back in once we have IUOE
// import QuestionLink from '../../controls/QuestionLink'
class Benefit extends Component {
  constructor () {
    super()
    this.viewDetails = this.viewDetails.bind(this)
    this.viewHistory = this.viewHistory.bind(this)
  }

  viewDetails (depId, typeId, type) {
    const formattedType = type.replace(/\s/g, '')
    this.props.push(`/Member/Benefits/${depId}/${typeId}/${formattedType}`)
  }

  viewHistory (depId, type) {
    this.props.push(`/Member/Benefits/${depId}/${type}/History`)
  }

  render () {
    const {
      selectedMember: memberId,
      classes = {}
    } = this.props
    let local = getFullLocale()
    const { wlKey } = Config
    const self = this
    if (this.props.benefits === undefined) {
      return (
        <div className=''>
          <Loading message={localize('common.loadingContent')} />
        </div>
      )
    } else {
      return (
        <div>
          {
            this.props.benefits.map(function (benefit, indx) {
              const memberBenefitCoverage = benefit.memberBenefitCoverage.find((mbc) => { return '' + mbc.depId === '' + memberId })
              const hcsaMessage = (benefit.isStandaloneHealthCareSpendingAccount === true ? ` - ${benefit.benefitType} ${localize('pages.benefitSummary.HCSAMessage')}` : '')
              const cardHeaderTitle = <div>{benefit.benefitType} <span className='benefitText'>{hcsaMessage}</span></div>
              // to be added back in once we have IUOE
              // const wageHeaderTitle = <div style={{display:'flex'}}><span style={{marginRight:10}}>{benefit.benefitType}</span> <QuestionLink title={'TODO - What is Wage Replacement and how does it work?'} content={'To Do'} /></div>
              return <div key={indx}>
                <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
                  <Row>
                    <Col xs>
                      <CardHeader
                        title={cardHeaderTitle}
                        aria-label={localize('pages.ariaLabel.benefit')}
                        classes={{ root: classes.root, title: classes.title }}
                      />
                    </Col>
                    <div className={local === 'en' ? 'benefitButtons' : 'benefitButtons_FR'}>
                      {memberBenefitCoverage && memberBenefitCoverage.isHistoryAvailable && <RBButton className='benefitButton' onClick={() => { self.viewHistory(memberId, benefit.benefitType) }} label={localize('pages.cardDetails.viewHistory')} variant='outlined' />}
                      {memberBenefitCoverage && memberBenefitCoverage.hasAccumRules && <RBButton className='benefitButton' label={localize('pages.cardDetails.viewDetails')} onClick={() => { self.viewDetails(memberId, benefit.id, benefit.benefitType) }} variant='outlined' />}
                    </div>
                  </Row>
                  <Divider />
                  <Row>
                    <Col {...Columns.max6}>
                      <TitledLabel title={'pages.cardDetails.status'} value={(memberBenefitCoverage && memberBenefitCoverage.status) || ''} />
                      { wlKey !== 'iuoe' && <Tooltip title={localize('pages.memberSummary.tooltip.benefitStatus')} placement="top-start">
                        <IconButton tabIndex={-1} className='waivedTooltip'>
                          <Icon style={{ fontSize: 20, color: Colors.Palette.primaryTextColor }}>info</Icon>
                        </IconButton>
                      </Tooltip> }
                    </Col>
                    <Col {...Columns.max6}>
                      {!Config.member.benefits.hideEffectiveDate && <TitledLabel title={'pages.benefits.cardDetails.effDate'} value={(memberBenefitCoverage && memberBenefitCoverage.benefitEffectiveDate) || ''} format='date' />}
                    </Col>
                    <Col {...Columns.max6}>
                      {!Config.member.benefits.hideExpiryDate && <TitledLabel title={'pages.benefits.cardDetails.expDate'} value={(memberBenefitCoverage && memberBenefitCoverage.benefitExpiryDate) || ''} format='date' /> }
                    </Col>
                    { wlKey !== 'iuoe' && <Col {...Columns.max6}>
                      {!Config.member.benefits.hideCoverage && <TitledLabel title={'pages.cardDetails.coverage'} value={benefit.benefitCoverage} />}
                    </Col> }
                  </Row>
                  <Row >
                    <Col className={local === 'en' ? 'responsive_buttons' : 'responsive_buttons_FR'}>
                      {memberBenefitCoverage && memberBenefitCoverage.isHistoryAvailable && <RBButton className='benefitButton' onClick={() => { self.viewHistory(memberId, benefit.benefitType) }} label={localize('pages.cardDetails.viewHistory')} variant='outlined' /> }
                      {memberBenefitCoverage && memberBenefitCoverage.hasAccumRules && <RBButton label={localize('pages.cardDetails.viewDetails')} onClick={() => { self.viewDetails(memberId, benefit.id, benefit.benefitType) }} variant='outlined' /> }
                    </Col>
                  </Row>
                </Card>
                <br />
              </div>
            })
          }
        </div>
      )
    }
  }
}

function mapStateToProps (state, ownProps) {
  return {
  }
}
function mapDispatchToProps (dispatch) {
  return {
    push: bindActionCreators(push, dispatch)
  }
}

const ConnectedBenefit = connect(mapStateToProps, mapDispatchToProps)(injectIntl(Benefit))

const styles = theme => ({
  ...MemberBenefitCardHeaderStyles(theme),
  ...CardStyles
})

export default withStyles(styles)(ConnectedBenefit)



// WEBPACK FOOTER //
// ./src/widgets/Member/Benefit.js